export const SYSTEM_ADDRESS = "systemAddress";
export const AVA_POINTS = "avaPoints";
export const WALLET = "wallet";

export const TRANSFER_TYPE = {
  SYSTEM_ADDRESS,
  AVA_POINTS,
  WALLET,
};

export const USDT = "USDT";
export const BTC = "BTC";
export const ETH = "ETH";

export const ASSET_TYPE = {
  USDT,
  BTC,
  ETH,
};
